import { Button } from "@/components/ui/button";
import { useAuth } from "@/hooks/useAuth";
import { Link, useNavigate } from "react-router-dom";
import { Menu } from "lucide-react";
import { useState } from "react";
import {
  Sheet,
  SheetContent,
  SheetTrigger,
} from "@/components/ui/sheet";
import logo from "@/assets/frequent-health-logo.jpeg";

export default function MarketingHeader() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const NavigationLinks = ({ isMobile = false }: { isMobile?: boolean }) => {
    const linkClassName = isMobile
      ? "block py-3 text-gray-light hover:text-white transition-colors text-lg"
      : "text-gray-light hover:text-white transition-colors";
    
    return (
      <>
        <Link 
          to="/about" 
          className={linkClassName}
          onClick={() => setMobileMenuOpen(false)}
        >
          About
        </Link>
        <Link 
          to="/how-it-works" 
          className={linkClassName}
          onClick={() => setMobileMenuOpen(false)}
        >
          How It Works
        </Link>
        <Link 
          to="/pricing" 
          className={linkClassName}
          onClick={() => setMobileMenuOpen(false)}
        >
          Membership
        </Link>
        <Link 
          to="/contact" 
          className={linkClassName}
          onClick={() => setMobileMenuOpen(false)}
        >
          Connect
        </Link>
      </>
    );
  };

  const AuthButtons = () => (
    <>
      {user ? (
        <Button
          className="font-bold uppercase tracking-wider shadow-neon-glow hover:scale-105 transition-all"
          onClick={() => {
            navigate("/client-portal");
            setMobileMenuOpen(false);
          }}
        >
          Dashboard
        </Button>
      ) : (
        <>
          <Button
            variant="outline"
            className="font-medium"
            onClick={() => {
              navigate("/login");
              setMobileMenuOpen(false);
            }}
          >
            Login
          </Button>
          <Button
            className="font-bold uppercase tracking-wider shadow-neon-glow hover:scale-105 transition-all"
            onClick={() => {
              navigate("/signup");
              setMobileMenuOpen(false);
            }}
          >
            Activate Health
          </Button>
        </>
      )}
    </>
  );

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-dark-bg/80 backdrop-blur-md border-b border-primary/10">
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center space-x-2">
            <img
              src={logo}
              alt="Frequent Health logo"
              className="h-12 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-6">
            <NavigationLinks isMobile={false} />
            <AuthButtons />
          </div>

          {/* Mobile Menu Button */}
          <Sheet open={mobileMenuOpen} onOpenChange={setMobileMenuOpen}>
            <SheetTrigger asChild>
              <Button
                variant="ghost"
                size="icon"
                className="md:hidden text-gray-light hover:text-white"
                aria-label="Open menu"
              >
                <Menu className="h-6 w-6" />
              </Button>
            </SheetTrigger>
            <SheetContent 
              side="right" 
              className="w-[300px] bg-dark-bg border-primary/10"
            >
              <div className="flex flex-col space-y-2 mt-8">
                <NavigationLinks isMobile={true} />
                <div className="flex flex-col space-y-3 pt-6 border-t border-primary/10">
                  <AuthButtons />
                </div>
              </div>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </nav>
  );
}


